import { useMemo } from 'react';

import { getPipelinePsets } from '../../data/apis/api';
import { useRestQuery } from '../../data/util';
import { QueryKey } from './config';
import { useImportState } from './Import/useImportState';

export const useFilePathPsetsData = (pipelinePath: string, disabled?: boolean, setPath?: (path: string) => void) => {
  const {
    transpilerState: { transpilerId }
  } = useImportState();
  const data = useRestQuery(
    [QueryKey, 'PipelinePsets', transpilerId, pipelinePath],
    () => getPipelinePsets(transpilerId, pipelinePath),
    {
      retry: false,
      enabled: Boolean(transpilerId && !disabled && pipelinePath),
      refetchOnMount: true,
      onSuccess: (resp) => {
        const respFiles = (resp.data || []) as unknown as string[];
        if (respFiles.length === 0 && setPath) {
          setPath('');
        }
      },
      sentryTag: 'transpiler.getPipelinePsets'
    }
  );

  const pipelinePsets = useMemo(() => data?.data?.data || [], [data?.data?.data]) as string[];

  return { isLoading: data.isLoading, pipelinePsets };
};
